module.exports = __webpack_public_path__ + "static/media/slide1.842ca842.jpg";